export const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
export const isAndroid = /Android/i.test(navigator.userAgent)

/**
 * Checks if the current device is iOS Safari.
 * Canvas size limitations are primarily an issue with iOS Safari browsers.
 */
export const isIOSSafari = (): boolean => {
  if (!isSafari) return false

  // Check if it's iOS using User Agent
  const userAgent = navigator.userAgent.toLowerCase()
  return /iphone|ipad|ipod/.test(userAgent)
}
